import { QueryFactory } from "../../../../Common";
export const QGetLeaguesBySportId = QueryFactory("GetLeaguesBySportId");
//# sourceMappingURL=QGetLeaguesBySportId.js.map